// extracted by mini-css-extract-plugin
export default {"section":"ApplicationFormSection_section__vrJb9","field--full-width":"ApplicationFormSection_field--full-width__AcMfi","field--break":"ApplicationFormSection_field--break__wNDl1"};